import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

const getters = {
  getIndividualEmployeeAwayList: (state) => state.items,
  getIndividualEmployeeAwayListPagination: (state) => state.pagination,
};

export default {
  actions,
  state,
  mutations,
  getters,
};
